import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer';
import MapView from '@arcgis/core/views/MapView';
import { MapViewInputTask } from 'cd-eft/components/Design/BreaklineTools/framework/MapViewInputTask';
import { GroundPoint } from 'cd-eft/components/Design/BreaklineTools/model/GroundPoint';
import { SurfaceDef } from 'cd-eft/components/Design/BreaklineTools/model/SurfaceDef';
import { SimpleMarkerSymbol } from 'cd-eft/utils/esriTypes';
import { onPickPointerMove, onToolCleanup } from '../utils/ToolUtils';

export class PickBorderPointInputTask extends MapViewInputTask<GroundPoint> {
  private readonly surfaceDef: SurfaceDef;

  private readonly tempBorderPointsLayer: GraphicsLayer = new GraphicsLayer({ title: 'tempBorderPointsLayer' });
  private readonly tempHighlightLayer: GraphicsLayer = new GraphicsLayer({ title: 'tempHighlightLayer' });

  private __highlightHandle: any;

  /**
   *
   * @param mapView
   * @param surfaceDef
   */
  constructor(mapView: MapView, surfaceDef: SurfaceDef) {
    super(mapView);
    this.surfaceDef = surfaceDef;
  }

  protected onSetup(): void {
    super.onSetup();
    this.cursor = 'pointer';

    if (this.__highlightHandle) {
      this.__highlightHandle.remove();
      this.__highlightHandle = undefined;
    }

    this.tempBorderPointsLayer.removeAll();
    this.tempHighlightLayer.removeAll();

    for (const borderPoint of this.surfaceDef.border.borderPoints) {
      const symbol = new SimpleMarkerSymbol({
        color: 'red',
        size: 8,
        outline: { style: 'none', color: 'transparent' },
      });
      const graphic = borderPoint.generateGraphic(this.mapView.spatialReference);
      graphic.symbol = symbol;
      this.tempBorderPointsLayer.add(graphic);
    }

    this.mapView.map.add(this.tempBorderPointsLayer);

    this.tempHighlightLayer.removeAll();
    this.mapView.map.add(this.tempHighlightLayer);
  }

  protected onCleanup(): void {
    super.onCleanup();
    onToolCleanup(this.__highlightHandle, this.tempBorderPointsLayer, this.mapView, this.tempHighlightLayer);
  }

  protected async onImmediateClick(e: __esri.ViewImmediateClickEvent): Promise<void> {
    super.onImmediateClick(e);

    const options: __esri.MapViewHitTestOptions = {};
    options.include = this.tempBorderPointsLayer;
    const hitTestResult = await this.mapView.hitTest(e, options);
    if (hitTestResult.results[0]) {
      const graphic = hitTestResult.results[0].graphic;
      const taskResult: GroundPoint = graphic.attributes;
      this.completeNow(taskResult);
    }
  }

  // protected onKeyDown(e: __esri.ViewKeyDownEvent): void {
  //   super.onKeyDown(e);
  // }

  protected async onPointerMove(e: __esri.ViewPointerMoveEvent): Promise<void> {
    await onPickPointerMove(e, this.tempHighlightLayer, this.tempBorderPointsLayer, this.mapView, this.__highlightHandle);
  }
}
